import { render } from "./toggler.vue?vue&type=template&id=ba1bc49a&scoped=true&ts=true"
import script from "./toggler.vue?vue&type=script&lang=ts"
export * from "./toggler.vue?vue&type=script&lang=ts"

import "./toggler.vue?vue&type=style&index=0&id=ba1bc49a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba1bc49a"]])

export default __exports__